import URI from "urijs";
import {ajaxAuthed, API_BASE, RESULT_LIMIT} from "./common";
import {APIError} from "../common/errors";

function getDocumentComments(buildUrl) {
  return function (params) {
    const { offset } = params;
    let url = buildUrl(params);
    let query = { limit: RESULT_LIMIT, offset };
    url.query(URI.buildQuery(query));
    return ajaxAuthed({ url: url.toString() });
  }
}

function createDocumentComment(buildUrl) {
  return function (params) {
    const { comment } = params;
    if (!comment) throw new APIError('no comment provided for createDocumentComment');
    let url = buildUrl(params);
    let body = {
      comment
    };
    return ajaxAuthed({ url: url.toString(), method: 'POST', body, headers: { 'Content-Type': 'application/json'} });
  }
}

const bidCommentUrl =  ({ bidId }) => {
  if (!bidId) throw new APIError('no bid id specified for bid comments');
  return URI.joinPaths(API_BASE, 'bids', bidId, 'comments');
};

export const getBidComments$ = getDocumentComments(bidCommentUrl);
export const createBidComments$ = createDocumentComment(bidCommentUrl);

const projectCommentUrl = ({ projectId }) => {
  if (!projectId) throw new APIError('no project id specified for project comments');
  return URI.joinPaths(API_BASE, 'projects', projectId, 'comments');
};

export const getProjectComments$ = getDocumentComments(projectCommentUrl);
export const createProjectComments$ = createDocumentComment(projectCommentUrl);

const meetingMinutesUrl = ({ projectId, meetingId }) => {
  if (!projectId) throw new APIError('no project id specified for meeting minutes comment');
  if (!meetingId) throw new APIError('no meeting id specified for meeting minutes comment');
  return URI.joinPaths(API_BASE, 'projects', projectId, 'meeting-minutes', meetingId, 'comments');
};

export const getMeetingMinutesComments$ = getDocumentComments(meetingMinutesUrl);
export const createMeetingMinutesComment$ = createDocumentComment(meetingMinutesUrl);

const dailyLogUrl = ({ projectId, logId }) => {
  if (!projectId) throw new APIError('no project id specified for daily log comment');
  if (!logId) throw new APIError('no log id specified for daily log comment');
  return URI.joinPaths(API_BASE, 'projects', projectId, 'daily-logs', logId, 'comments');
};

export const getDailyLogComments$ = getDocumentComments(dailyLogUrl);
export const createDailyLogComment$ = createDocumentComment(dailyLogUrl);

const rfiUrl = ({ projectId, rfiId }) => {
  if (!projectId) throw new APIError('no project id specified for rfi comment');
  if (!rfiId) throw new APIError('no rfi id specified for rfi comment');
  return URI.joinPaths(API_BASE, 'projects', projectId, 'project-rfis', rfiId, 'comments');
};

export const getRfiComments$ = getDocumentComments(rfiUrl);
export const createRfiComment$ = createDocumentComment(rfiUrl);

const punchesUrl = ({ projectId, punchId }) => {
  if (!projectId) throw new APIError('no project id specified for punch list comment');
  if (!punchId) throw new APIError('no punch id specified for punch list comment');
  return URI.joinPaths(API_BASE, 'projects', projectId, 'punches', punchId, 'comments');
};

export const getPunchComments$ = getDocumentComments(punchesUrl);
export const createPunchComment$ = createDocumentComment(punchesUrl);

const submittalUrl = ({ projectId, submittalId }) => {
  if (!projectId) throw new APIError('no project id specified for submittal comment');
  if (!submittalId) throw new APIError('no submittal id specified for submittal comment');
  return URI.joinPaths(API_BASE, 'projects', projectId, 'submittals', submittalId, 'comments');
};

export const getSubmittalComments$ = getDocumentComments(submittalUrl);
export const createSubmittalComment$ = createDocumentComment(submittalUrl);

const taskUrl = ({ projectId, taskId }) => {
  if (!projectId) throw new APIError('no project id specified for task comment');
  if (!taskId) throw new APIError('no task id specified for task comment');
  return URI.joinPaths(API_BASE, 'projects', projectId, 'tasks', taskId, 'comments');
};

export const getTaskComments$ = getDocumentComments(taskUrl);
export const createTaskComment$ = getDocumentComments(taskUrl);




// WEBPACK FOOTER //
// ./src/services/comments.js